import React from 'react';
import { Package, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * PantryCardWidget - Quick access to pantry inventory
 * Priority 4: Reference what you have
 */
export default function PantryCardWidget({ 
  stockedItems = [], 
  onNavigate 
}) {
  const itemCount = stockedItems.length;

  return (
    <button
      onClick={() => onNavigate && onNavigate('pantry')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: '#FEF3C7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Package size={20} color="#D97706" />
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          Pantry
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: ABLE_COLORS.textSecondary,
        }}>
          {itemCount === 0 ? "Add ingredients" : "View ingredients"}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
